module.exports = __webpack_public_path__ + "img/no-collector.3f9c980f.jpg";